import React from "react";
import { defineMessages } from "react-intl";
import TextField from "./TextField";

const messages = defineMessages({
  invalidPasswordFieldError: {
    id: "invalidPasswordFieldError",
    defaultMessage: "At least 1 letter, 1 number and 1 special character is required."
  },
  minimum8: {
    id: "minimum8",
    defaultMessage: "At least 8 charachters are required."
  }
});

const PasswordField = props => (
  <TextField
    {...props}
    secureTextEntry={true}
  />
);

export default PasswordField;
